import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconButton } from "@mui/material";
import { ReactComponent as ArrowUpIcon } from "Components/_Shared/Icons/Assets/arrow-up.svg";
import type React from "react";
import { useState } from "react";

type RotatingArrowButtonProps = {
  onClick: () => void;
};

const RotatingArrowButton: React.FC<RotatingArrowButtonProps> = ({ onClick }) => {
  const [rotated, setRotated] = useState(false);

  const handleClick = () => {
    setRotated((prev) => !prev);
  };

  return (
    <IconButton
      onClick={() => {
        handleClick();
        onClick();
      }}
    >
      <ArrowUpIcon
        style={{
          // otočení o 180° když rotated=true, jinak 0°
          transform: rotated ? "rotate(0deg)" : "rotate(180deg)",
          transition: "transform 0.3s ease",
        }}
      />
    </IconButton>
  );
};

export default RotatingArrowButton;
